export function formatCompactNumber(value) {
  if (value === null || value === undefined || isNaN(value)) return "-";

  const absValue = Math.abs(value);
  const formatter = new Intl.NumberFormat("it-IT", {
    maximumFractionDigits: 1,
  });

  if (absValue < 1_000) {
    return formatter.format(value);
  } else if (absValue < 1_000_000) {
    // migliaia
    return formatter.format(value / 1_000) + " mila";
  } else if (absValue < 1_000_000_000) {
    // milioni
    return formatter.format(value / 1_000_000) + " milioni";
  } else {
    // miliardi e oltre
    return formatter.format(value / 1_000_000_000) + " mld";
  }
}